module.exports = __webpack_public_path__ + "static/media/2024-image04.b9c56945.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/2024-image04.jpg
// module id = 76
// module chunks = 0